<template>
    <div v-if="value">
        <input-text
            :label="_mft('form:field.title.label')"
            :required="true"
            v-model:content="value.title"
        />

        <div class="flex justify-between space-x-2">
            <input-number
                class="max-w-48"
                :label="_mft('form:statistics.type.min.title')"
                v-model:content="value.minValue"
            />
            <input-number
                class="max-w-48"
                :label="_mft('form:statistics.type.max.title')"
                v-model:content="value.maxValue"
            />
        </div>

        <div class="mt-6 mb-4">
            <div class="flex justify-between border-t-2 mx-4">
                <div
                    v-for="n in valueStops"
                    :key="n"
                    class="h-4 border-r border-2 -translate-y-2 -mt-px relative"
                >
                    <span
                        class="absolute left-0 bottom-full transform -translate-x-1/2 mb-1.5 text-xs text-gray-400"
                    >{{ n }}</span>
                </div>
            </div>
            <div class="flex justify-between">
                <div class="w-24">
                    <input-text
                        :label="_mft('form:field.label')"
                        :required="false"
                        v-model:content="value.lowSymbol"
                        :placeholder="_mft('shared:egShort') + ' ☹️'"
                    />
                </div>

                <div class="w-24">
                    <input-text
                        :label="_mft('form:field.label')"
                        :required="false"
                        v-model:content="value.midSymbol"
                        :placeholder="_mft('shared:egShort') + ' 🙂'"
                    />
                </div>

                <div class="w-24">
                    <input-text
                        :label="_mft('form:field.label')"
                        :required="false"
                        v-model:content="value.highSymbol"
                        :placeholder="_mft('shared:egShort') + ' 😄'"
                    />
                </div>
            </div>
        </div>

        <toggle-switch
            :label="_mft('form:required')"
            v-model:content="value.required"
        ></toggle-switch>

        <toggle-switch
            :label="_mft('form:field.showMoreInfo')"
            v-model:content="value.showInstructions"
        ></toggle-switch>

        <Instructions
            :model-value="value"
        />
    </div>
    <mf-spinner-medium v-else class="w-16 h-8"></mf-spinner-medium>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
import Instructions from './_instructions.vue'

export default {
    components: {Instructions},
    props: {
        modelValue: {},
    },
    emits: [
        'update:modelValue'
    ],
    data() {
        return {
            value: null,
            showInstructions: false,
        };
    },
    async mounted() {
        this.captureModelValue();
    },
    watch: {
        modelValue() {
            if (JSON.stringify(this.value) === JSON.stringify(this.modelValue)) {
                return;
            }
            this.captureModelValue();
        },
        value: {
            handler() {
                this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.value)));
            },
            deep: true
        },
    },
    computed: {
        valueStops() {
            if (!this.value) {
                return [];
            }
            const stops = [];
            const min = parseInt(this.value.minValue);
            const max = parseInt(this.value.maxValue);
            if (max > 16) {
                const step = Math.max(1, Math.floor((max - min)));
                for (let i = min; i <= max; i += step) {
                    stops.push(i);
                }
                if (stops[stops.length - 1] !== max) {
                    stops.push(max);
                }
            } else {
                for (let i = min; i <= max; i++) {
                    stops.push(i);
                }
            }
            return stops;
        }
    },
    methods: {
        captureModelValue() {
            const value = this.modelValue ? JSON.parse(JSON.stringify(this.modelValue)) : {};
            if (!value.uuid) {
                value.uuid = uuidv4();
            }
            if (!value.title) {
                value.title = null;
            }
            if (!value.showInstructions) {
                value.showInstructions = false;
            }
            if (!value.metaText) {
                value.metaText = null;
            }
            if (!value.metaImage) {
                value.metaImage = null;
            }
            if (!value.metaVideo) {
                value.metaVideo = null;
            }
            if (!value.required) {
                value.required = false;
            }
            if (!value.lowSymbol) {
                value.lowSymbol = ''
            }
            if (!value.midSymbol) {
                value.midSymbol = ''
            }
            if (!value.highSymbol) {
                value.highSymbol = ''
            }
            if (!value.minValue) {
                value.minValue = 1;
            }
            if (!value.maxValue) {
                value.maxValue = 5;
            }
            this.value = value;
        }
    },
}
</script>
